import Vue from 'vue';
import * as TYPES from './types';
import http from '@/utils/api';

const namespaced = true;

const state = () => ({
  isLoading: false,
  error: {
    ErrorCode: null,
    message: '',
  },
  user: null,
})

const actions = {
  async authorize ({ commit }, data) {
    commit(TYPES.SET_ERROR, { ErrorCode: null, message: '', });
    commit(TYPES.SET_LOADING, { status: true, });
    try {
      const response = await http.post('/login', data);
      commit(TYPES.SET_LOADING, { status: false, });
      const result = response.data;

      if ([401, 403].includes(result.ErrorCode)) commit(TYPES.SET_ERROR, result);
      if (result && result.key && result.user) {
        commit(TYPES.SET_USER, result.user);
        Vue.$storage.set('token', result.key);
        Vue.$storage.set('user-info', result.user);
      }

      return result;
    } catch(e) {
      console.log(e);
    }
  },
}

const mutations = {
  [TYPES.SET_LOADING](state, payload) {
    state.isLoading = payload.status;
  },

  [TYPES.SET_ERROR](state, payload) {
    state.user = null;
    state.error = payload;
  },

  [TYPES.SET_USER](state, payload) {
    state.user = payload;
  },

  [TYPES.USER_LOGOUT](state, payload) {
    Vue.$storage.remove('token');
    Vue.$storage.remove('user-info');
    // localStorage.removeItem('token');
    // localStorage.removeItem('user-info');
  },
}

export default {
  namespaced,
  actions,
  state,
  mutations,
};
